import * as React from 'react';

interface Props {
    isActive: boolean;
    className: string;
    tkey: string;
    label: string;
    inactiveNavCalloutNode?: React.ReactNode;
    activeNavCalloutNode?: React.ReactNode;
}

export default class TabListItem extends React.PureComponent<Props> {
    static defaultProps = {
        isActive: false,
        className: '',
    };

    render() {
        const { children, isActive, className } = this.props;

        let classNames: Array<string> = [className, 'ddbc-tab-list__item'];
        if (isActive) {
            classNames = [...classNames, 'ddbc-tab-list__item--active'];
        }

        return <div className={classNames.join(' ')}>{children}</div>;
    }
}
